import PageHeader from '@/components/layout/PageHeader';
import React, { useEffect, useState } from 'react';
import ajax from '@/scripts/ajax';
import dayjs from 'dayjs';
import localforage from 'localforage';
import { DatePicker, Card, message, Popconfirm, Row, Col, Form, Button, Table, Select } from 'antd';
import { endArray } from 'bfj/src/events';
let len = 0;
let oldSelectRowKeys = [];
// const pageKey = 'UserList'; //页面身份
export default function UserList() {
    const [dataSource, setState] = useState([]);
    const [firstNameArr, setFirstNameArr] = useState([]);
    const [lastNameArr, setLastNameArr] = useState([]);
    const [selectedRowsValue, setSelectedRows] = useState([]);
    const [dataSaver, setList] = useState([]);
    const [firstDataSaver, setFirstList] = useState([]);
    const [timeDataSaver, setTime] = useState([]);
    const today = dayjs(); //当天日期
    // const firstValue = 'NingBo';

    useEffect(() => {
        Promise.all([localforage.getItem('first_Name'), localforage.getItem('last_Name'), localforage.getItem('time')]).then((res) => {
            // const [firstList = [], list = [], time = []] = res;
            const firstList = res[0] || [];
            const list = res[1] || [];
            const time = res[2] || [];
            setFirstList(firstList);
            setList(list);
            setTime(time);
            // 获取用户名
            ajax.get('user/list')
                .then((response) => {
                    // 添加禁用状态 默认false
                    const data = response.map((item) => {
                        console.log(item, 'item');
                        const originCity = firstList?.find((c) => c.id === item.id)?.value || '';
                        const destinationCity = list?.find((c) => c.id === item.id)?.value || '';
                        const timeValue = time?.find((c) => c.id === item.id)?.value || today.format('YYYY-MM-DD');
                        item.update_time = dayjs(item.update_time).format('YYYY-MM-DD HH:mm:ss');
                        return {
                            ...item,
                            isDisabled: false,
                            originCity,
                            destinationCity,
                            timeValue,
                        };
                    });

                    setState(data);
                })
                .catch((err) => {
                    console.log(err);
                });
        });
       
        // 获取起始港
        ajax.get('startport?location=1')
            .then((response) => {
                const data = response;
                setFirstNameArr(data);
            })
            .catch((err) => {
                console.log(err);
            });

        // 获取目的港
        ajax.get('endport?location=1')
            .then((response) => {
                const data = response;
                setLastNameArr(data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    //多选
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            // debugger;
            const selectedRowsValue = selectedRows;
            setSelectedRows(selectedRowsValue);
            let startArr = [],
                endArr = [];
            dataSource.forEach((item) => {
                let isSelect = selectedRowKeys.includes(item.id);
                if (isSelect) {
                    startArr.push(item);
                } else {
                    endArr.push(item);
                }
            });
            let newData = [...startArr, ...endArr];
            setState(newData);
        },
    };

    // 起始港下拉
    const firstChange = (value, text, record) => {
        let id = record.id;
        setState(
            dataSource.map((item) => {
                if (item.id === id) {
                    item.originCity = value;
                    let firstDataSaverList = {
                        id: item.id,
                        value: value,
                    };
                    let firstSaverListAll = [];
                    firstSaverListAll.unshift(firstDataSaverList);
                    firstSaverListAll.forEach((el) => {
                        if (!firstDataSaver.some((e) => e.id === el.id)) {
                            firstDataSaver.push(el);
                        } else {
                            firstDataSaver.map((item) => {
                                if (item.id === el.id) {
                                    item.value = el.value;
                                }
                                return item;
                            });
                        }
                    });
                    localforage.setItem('first_Name', firstDataSaver);
                }
                return item;
            }),
        );
    };

    // 目的港下拉
    const lastChange = (value, text, record) => {
        let id = record.id;
        setState(
            dataSource.map((item) => {
                if (item.id === id) {
                    item.destinationCity = value;
                    let dataSaverList = {
                        id: item.id,
                        value: value,
                    };
                    let dataSaverListAll = [];
                    dataSaverListAll.unshift(dataSaverList);
                    dataSaverListAll.forEach((el) => {
                        if (!dataSaver.some((e) => e.id === el.id)) {
                            dataSaver.push(el);
                        } else {
                            dataSaver.map((item) => {
                                if (item.id === el.id) {
                                    item.value = el.value;
                                }
                                return item;
                            });
                        }
                    });
                    localforage.setItem('last_Name', dataSaver);
                }

                return item;
            }),
        );
    };

    // 选择日期
    const timeChange = (value, dateString, text, record) => {
        let id = record.id;
        setState(
            dataSource.map((item) => {
                if (item.id === id) {
                    item.timeValue = dateString;
                    const timeData = {
                        id: item.id,
                        value: dateString,
                    };
                    let timeList = [];
                    timeList.unshift(timeData);
                    timeList.forEach((el) => {
                        if (!timeDataSaver.some((e) => e.id === el.id)) {
                            timeDataSaver.push(el);
                        } else {
                            timeDataSaver.map((item) => {
                                if (item.id === el.id) {
                                    item.value = el.value;
                                }
                                return item;
                            });
                        }
                    });
                }
                localforage.setItem('time', timeDataSaver);
                return item;
            }),
        );
    };

    // 锁定
    const locked = (text, record, index) => {
        let id = text.id;
        setState(
            dataSource.map((item) => {
                if (item.id === id && item.destinationCity !== '') {
                    item.isDisabled = true;
                    const params = {
                        id: item.id,
                        origin_city: item.originCity,
                        destination_city: item.destinationCity,
                        earliest_departure_date: item.timeValue,
                    };
                    ajax.post('go/locked', params)
                        .then((response) => {
                            if (response !== null) {
                                message.success(response);
                            }
                        })
                        .catch((err) => {
                            // message.error(err.response.data.msg);
                            console.log(err.response.data.msg);
                        });
                }
                return item;
            }),
        );
        setState(
            dataSource.map((item) => {
                if (item.id === id && item.destinationCity === '') {
                    message.warning('请选择起始港和目的港');
                }
                return item;
            }),
        );
    };

    // 勾选锁定
    const checkLock = () => {
        if (selectedRowsValue.length === 0) {
            message.warning('请选择数据');
            return;
        }
        if (selectedRowsValue.some((item) => item.destinationCity === '')) {
            message.warning('请选择起始港和目的港');
            return;
        } else if (selectedRowsValue.some((item) => item.isDisabled !== false)) {
            message.warning('请选择未锁定的数据');
            return;
        } else {
            setSelectedRows(
                selectedRowsValue.forEach((item) => {
                    item.isDisabled = true;
                    const params = {
                        id: item.id,
                        origin_city: item.originCity,
                        destination_city: item.destinationCity,
                        earliest_departure_date: item.timeValue,
                    };
                    ajax.post('go/locked', params)
                        .then((response) => {
                            message.success(response);
                        })
                        .catch((err) => {
                            item.isDisabled = false;
                            console.log(err);
                        });
                }),
            );
        }
    };

    const columns = [
        {
            title: '用户名',
            dataIndex: 'username',
            render: (text, record) => (
                <Popconfirm
                    icon=""
                    title=""
                    showCancel={false}
                    description={`
                         用户名：${record.username}
                         公司信息：${record.trading_name}
                        `}
                    okType="default"
                    okText="关闭"
                >
                    <a href="#">{text}</a>
                </Popconfirm>
            ),
        },
        {
            title: '公司信息',
            dataIndex: 'trading_name',
        },
        {
            title: '更新时间',
            dataIndex: 'update_time',
            align: 'center',
            sorter: (a, b) => +new Date(a.update_time) - +new Date(b.update_time),
        },
        {
            title: '起始港',
            dataIndex: 'firstName',
            align: 'center',
            type: 'select',
            render: (text, record, index) => {
                let options = firstNameArr.map((item, index) => {
                    return { label: item, value: item, key: index };
                });
                // let FirstName = firstDataSaver.filter((e) => e.id === record.id);
                return (
                    <Select
                        showSearch
                        onChange={(value) => firstChange(value, text, record)}
                        // defaultValue={FirstName.length ? FirstName : ''}
                        defaultValue={firstDataSaver.filter((e) => e.id === record.id)}
                        style={{ width: 120 }}
                        options={options}
                    ></Select>
                );
            },
        },
        {
            title: '目的港',
            dataIndex: 'lastName',
            align: 'center',
            width: 180,
            render: (text, record) => {
                let options = lastNameArr.map((item, index) => {
                    return { label: item, value: item, key: index };
                });
                return (
                    <Select
                        defaultValue={dataSaver.filter((e) => e.id === record.id)}
                        showSearch
                        onChange={(value) => lastChange(value, text, record)}
                        style={{ width: 180 }}
                        options={options}
                    ></Select>
                );
            },
        },
        {
            title: '日期',
            dataIndex: 'time',
            align: 'center',
            render: (text, record) => {
                let timeDefault = dayjs(timeDataSaver.find((e) => e.id === record.id)?.value) || today;
                return (
                    <DatePicker
                        defaultValue={timeDefault}
                        allowClear={false}
                        onChange={(value, dateString) => timeChange(value, dateString, text, record)}
                        style={{ width: 120 }}
                    ></DatePicker>
                );
            },
        },
        {
            title: '操作',
            dataIndex: '',
            align: 'center',
            render: (text, record, index) => (
                <Button disabled={text.isDisabled} onClick={() => locked(text, record, index)} type="primary">
                    锁定
                </Button>
            ),
        },
    ];
    return (
        <div className="username-list">
            <PageHeader title="Maersk Go用户列表" sticky></PageHeader>
            <Form className="formStyle" autoComplete="off">
                <Card className="ax-search-card">
                    <Row gutter={[16, 24]} style={{ width: '100%' }}>
                        <Col span={10} offset={21} className="gutter-row">
                            <Form.Item>
                                <Button type="primary" onClick={checkLock}>
                                    勾选锁定
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Card>
            </Form>
            <Table
                className="List"
                rowSelection={rowSelection}
                rowKey={(record) => record.id}
                pagination={false}
                dataSource={dataSource}
                columns={columns}
            />
        </div>
    );
}
